import React from 'react';
import { Link } from 'react-router-dom';
import AppLayout from '../../layouts/app/AppLayout';
// import ContactUsForm from '../../forms/contactUs.form';
import ContactForm from '../../components/contactForm/ContactForm';
import AppIcons from '../../assets/images/icons';
import './custom.scss';
import { translateThis } from '../../helpers/language.helper';
import SVGIcons from '../../assets/images/icons/svgIcons';





const ContactUsPage = () => {
    // custom register functions here
    const pageName = 'Contact us';
    return (
        <AppLayout
            pageName={pageName}
        >
            <div className="main-content-wrapper contactUs-main-wrapper f-wrp">
                <div className='contact-banner-wrp f-wrp'>
                    <div className='main-container-wrp'>
                        <div className='contact-form-box f-wrp'>
                            <span className='contactBG-img'><img src={AppIcons.contactUS} alt={'Contact Us'} /></span>
                            <ContactForm />
                        </div>
                    </div>
                </div>
                <div className='contact-con-wrp f-wrp'>
                    <span className='contactUsBG-img'><img src={AppIcons.contactUsBG} alt={'Contact'} /></span>
                    <div className='main-container-wrp'>
                        <div className='contact-grid-header f-wrp'>
                            <h1>{translateThis('Contact')}</h1>
                        </div>
                        <div className='contact-grid-wrp f-wrp'>
                            <div className='each-grid-wrp contact-box f-wrp'>
                                <div className='con-box f-wrp'>
                                    <span className='icon'><SVGIcons.MessageIcon /></span>
                                    <p>{translateThis('Call Anytime')}</p>
                                    <Link to="tel:+254762648599">+254 762 648599</Link>
                                </div>
                            </div>
                            <div className='each-grid-wrp mail-box f-wrp'>
                                <div className='con-box f-wrp'>
                                    <span className='icon'><SVGIcons.MailIcon /></span>
                                    <p>{translateThis('Send Email')}</p>
                                    <Link to="mailto:info@wdp-igo.org">info@wdp-igo.org</Link>
                                </div>
                            </div>
                            <div className='each-grid-wrp map-box f-wrp'>
                                <div className='con-box f-wrp'>
                                    <span className='icon'><SVGIcons.ContactPointerIcon /></span>
                                    <p>{translateThis('Visit Office')}</p>
                                    <h5>{translateThis('UN Avenue, Runda, Mumwe Drive 128, Naiirobi, Kenya')}</h5>
                                    {/* <h5>{translateThis('Dubai Chambers, Baniyas Road - Deira, UAE')}</h5> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='map-box f-wrp'>
                    <iframe title='location' src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d510579.1247214259!2d36.813478!3d-1.229718!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f17c7baeb1ed1%3A0xd2e55521b05daa01!2sUnited%20Nations%20Ave%2C%20Nairobi%2C%20Kenya!5e0!3m2!1sen!2sus!4v1722628112630!5m2!1sen!2sus" width="100%" height="350" style={{ border: "0" }} allowfullscreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
                </div>
            </div>








        </AppLayout>
    )
}

export default ContactUsPage;